const ChromeOSPwaExtensionMessaging = require("./ChromeOSPwaExtensionMessaging");

const Platform = require("../Platform");
const Utils = require("../Utils");

const service = {};

const INITIALIZATION_RETRY_INTERVAL_MS = 500;
const MAX_INITIALIZATION_RETRY_INTERVAL_MS = 30000;
const MAX_INITIALIZATION_RETRY_ATTEMPTS = 10;

const attemptInitialization = (resolve, reject, attempt, retryIntervalMs) => {
  ChromeOSPwaExtensionMessaging.initializeAndGetConfiguration()
  .then(response => resolve(response))
  .catch(error => {
    if( attempt >= MAX_INITIALIZATION_RETRY_ATTEMPTS ) {
      reject(error)
    } else {
      const newAttempt = attempt + 1;
      const nextRetryIntervalMs = Math.min(retryIntervalMs * 2, MAX_INITIALIZATION_RETRY_INTERVAL_MS);

      console.warn(`PWA extension initialization failed. Attempt ${newAttempt} of ${MAX_INITIALIZATION_RETRY_ATTEMPTS}. Retrying in ${nextRetryIntervalMs}ms...`);
      setTimeout(() => attemptInitialization(resolve, reject, newAttempt, nextRetryIntervalMs), nextRetryIntervalMs)
    }
  })
}

service.initializeAndGetConfiguration = () => {
  return new Promise(( resolve, reject ) => {
    if (!Utils.isChromeOSBrowser())  {
      reject(new Error(`User agent '${Platform.getUserAgent()}' is not Chrome OS, so this is not a Chrome OS PWA Player`))

      return
    }
  
    if (!ChromeOSPwaExtensionMessaging.isChromeRuntimeAvailable()) {
      reject(new Error('chrome.runtime is not available, so this is not a Chrome OS PWA Player'))

      return
    }

    attemptInitialization(resolve, reject, 0, INITIALIZATION_RETRY_INTERVAL_MS)
  })
}

module.exports = service;
